module.exports = __webpack_public_path__ + "static/media/2022_2A3A0796.7f4cc101.jpg";